import { render, staticRenderFns } from "./formInterposeInstance.vue?vue&type=template&id=d64ba144&scoped=true&"
import script from "./formInterposeInstance.vue?vue&type=script&lang=js&"
export * from "./formInterposeInstance.vue?vue&type=script&lang=js&"
import style0 from "./formInterposeInstance.vue?vue&type=style&index=0&id=d64ba144&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64ba144",
  null
  
)

export default component.exports